module.exports = __webpack_public_path__ + "assets/30e54d99fb5842580713dad874b2388b.png";